import React, { Component } from "react";
import './Header.css'

class Header extends Component {
    render() {
        const aamlogo = process.env.BASE_URL + "images/shared/header-aam-logo.png";
        const aamMobilelogo = process.env.BASE_URL + "images/shared/header-aam-mobile-logo.png";
        const ssglogo = process.env.BASE_URL + "images/shared/ThalesLogo.png";
        const ssgMobile = process.env.BASE_URL + "images/shared/GemaltoMobile.png";
        return (
            <div className="header-container">
                <div id="header">
                   
                    <div className="header-aam-logo">
                     {/*eslint-disable-next-line react/jsx-no-target-blank*/}
                    <a href="https://www.thalesgroup.com/en/markets/digital-identity-and-security/banking-payment/issuance/perso/artwork-services/all-about-me" target="_blank">
                    <img src={aamlogo} className="aam-logo-image" alt="AAM Resources" />
                    <img src={aamMobilelogo} className="aam-mobile-logo-image" alt="AAM Resources" />
                    </a>
                    </div>
                    <div className="aam-heading">
                        Card Customization Resource Site
                    </div>
                    
                    <div className="header-company-logo">
                    {/*eslint-disable-next-line react/jsx-no-target-blank*/}
                    <a href="https://www.thalesgroup.com/en"  target="_blank">
                        <img src={ssglogo} className="company-logo" alt="AAM Resources" />
                        <img src={ssgMobile} className="company-mobile-logo" alt="AAM Resources" />
                    </a>
                    </div>
                </div>
            </div>
        );
    }
}

export default Header;